import _defineProperty from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { dsnToString, createEnvelope, dropUndefinedKeys, getSentryBaggageItems } from '@sentry/utils';
/** Extract sdk info from from the API metadata */

function getSdkMetadataForEnvelopeHeader(metadata) {
  if (!metadata || !metadata.sdk) {
    return;
  }

  var _metadata$sdk = metadata.sdk,
      name = _metadata$sdk.name,
      version = _metadata$sdk.version;
  return {
    name: name,
    version: version
  };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/


function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }

  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [].concat(_toConsumableArray(event.sdk.integrations || []), _toConsumableArray(sdkInfo.integrations || []));
  event.sdk.packages = [].concat(_toConsumableArray(event.sdk.packages || []), _toConsumableArray(sdkInfo.packages || []));
  return event;
}
/** Creates an envelope from a Session */


function createSessionEnvelope(session, dsn, metadata, tunnel) {
  var sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);

  var envelopeHeaders = _objectSpread(_objectSpread({
    sent_at: new Date().toISOString()
  }, sdkInfo && {
    sdk: sdkInfo
  }), !!tunnel && {
    dsn: dsnToString(dsn)
  });

  var envelopeItem = 'aggregates' in session ? [{
    type: 'sessions'
  }, session] : [{
    type: 'session'
  }, session];
  return createEnvelope(envelopeHeaders, [envelopeItem]);
}
/**
 * Create an Envelope from an event.
 */


function createEventEnvelope(event, dsn, metadata, tunnel) {
  var sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  var eventType = event.type || 'event';

  var _ref = event.sdkProcessingMetadata || {},
      transactionSampling = _ref.transactionSampling;

  var _ref2 = transactionSampling || {},
      samplingMethod = _ref2.method,
      sampleRate = _ref2.rate;

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
  var envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn); // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)

  delete event.sdkProcessingMetadata;
  var eventItem = [{
    type: eventType,
    sample_rates: [{
      id: samplingMethod,
      rate: sampleRate
    }]
  }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}

function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
  var baggage = event.sdkProcessingMetadata && event.sdkProcessingMetadata.baggage;
  var dynamicSamplingContext = baggage && getSentryBaggageItems(baggage);
  return _objectSpread(_objectSpread(_objectSpread({
    event_id: event.event_id,
    sent_at: new Date().toISOString()
  }, sdkInfo && {
    sdk: sdkInfo
  }), !!tunnel && {
    dsn: dsnToString(dsn)
  }), event.type === 'transaction' && dynamicSamplingContext && {
    trace: dropUndefinedKeys(_objectSpread({}, dynamicSamplingContext))
  });
}

export { createEventEnvelope, createSessionEnvelope };